<script>
import Vue from "vue";
export default {
  name: "alert-notification",
  data() {
    return {
      mAlertWrapper: null,
      // snackbar message
      alertRandomID: 1,
      alerts: []
    };
  },
  methods: {
    alertConfirm(msg, onClick) {
      let id = ++this.alertRandomID;
      let newAlert = {
        id: id,
        isShow: false,
        msg: msg,
        isConfirm: true,
        'onClick': ()=>{
          onClick()
          this.removeAlertMessage(id);
        }
      };
      this.alerts.splice(0, 0, newAlert);
      this.$nextTick(() => {
        newAlert.isShow = true;
      });
      // setTimeout(() => {
      //   this.removeAlertMessage(id);
      // }, 3000);
    },
    alertMessage(msg) {
      let id = ++this.alertRandomID;
      let newAlert = {
        id: id,
        isShow: false,
        msg: msg
      };
      this.alerts.splice(0, 0, newAlert);
      this.$nextTick(() => {
        newAlert.isShow = true;
      });
      setTimeout(() => {
        this.removeAlertMessage(id);
      }, 3000);
    },
    removeAlertMessage(id) {
      let idx = this.alerts.findIndex(o => o.id === id);
      if (idx < 0) return;
      this.alerts[idx].isShow = false;
      this.alerts.splice(idx, 1);
    }
  },
  mounted() {
    let targetParent =
      document.body.querySelector(".v-application") || document.body;
    this.mAlertWrapper = this.$refs.alertWrapper;
    if (!this.mAlertWrapper)
      return window.console.warn(
        "mixin-vuetify-alert: mAlertWrapper Not Found."
      );
    if (this.mAlertWrapper.parentElement === targetParent) return;
    this.mAlertWrapper.remove();
    targetParent.appendChild(this.mAlertWrapper);

    Vue.prototype.$alertMessage = this.alertMessage;
    Vue.prototype.$alertConfirm = this.alertConfirm;
  },
  beforeDestroy() {
    if (this.mAlertWrapper) this.mAlertWrapper.remove();
    Vue.prototype.$alertMessage = null;
    Vue.prototype.$alertConfirm = null;
  }
};
</script>
